import type { enBoBudgets } from '../en/bo-budgets';

export const idBoBudgets: Record<keyof typeof enBoBudgets, string> = {
  'bo.budgets.title': 'Anggaran',
  'bo.budgets.subtitle':
    'Pos anggaran bulanan {branch} per pusat biaya dan kategori, beserta komitmen dan realisasinya.',
  'bo.budgets.noBranch': 'Pos anggaran dibuat per cabang.',
  'bo.budgets.add': 'Tambah pos anggaran',
  'bo.budgets.readOnly': 'Hanya baca — peran Anda tidak dapat membuat atau mengubah pos anggaran.',
  'bo.budgets.readOnlyApprover':
    'Peran Anda dapat menyetujui atau menolak usulan nilai, tetapi tidak dapat membuat atau mengubah pos anggaran.',
  'bo.budgets.noPermission': 'Peran Anda tidak dapat melihat anggaran.',

  'bo.budgets.periodTitle': 'Periode',
  'bo.budgets.periodDesc': 'Pos anggaran direncanakan per bulan kalender.',
  'bo.budgets.prevMonth': 'Bulan sebelumnya',
  'bo.budgets.nextMonth': 'Bulan berikutnya',
  'bo.budgets.thisMonth': 'Bulan ini',

  'bo.budgets.listTitle': 'Pos anggaran · {period}',
  'bo.budgets.listDesc':
    'Nilai disetujui dibandingkan komitmen terbuka dan realisasi. Waktu dalam {timeZone}.',
  'bo.budgets.empty':
    'Belum ada pos anggaran untuk {period}. Pos muncul setelah manajer membuatnya dan orang lain menyetujuinya.',
  'bo.budgets.emptyManage':
    'Belum ada pos anggaran untuk {period}. Tambahkan pos per pusat biaya dan kategori; nilainya disetujui oleh orang lain.',
  'bo.budgets.refreshing': 'Memperbarui…',
  'bo.budgets.stale': 'Gagal memperbarui — menampilkan data terakhir.',
  'bo.budgets.total': 'Total',
  'bo.budgets.sodNote':
    'Pemisahan tugas: pengusul suatu nilai tidak dapat menyetujui atau menolaknya.',

  'bo.budgets.col.costCenter': 'Pusat biaya',
  'bo.budgets.col.category': 'Kategori',
  'bo.budgets.col.approved': 'Disetujui',
  'bo.budgets.col.committed': 'Komitmen',
  'bo.budgets.col.actual': 'Realisasi',
  'bo.budgets.col.available': 'Sisa',
  'bo.budgets.col.utilization': 'Pemakaian',
  'bo.budgets.col.status': 'Status',
  'bo.budgets.col.proposal': 'Usulan',
  'bo.budgets.col.policy': 'Jika melebihi',

  'bo.budgets.status.draft': 'Draf',
  'bo.budgets.status.approved': 'Disetujui',
  'bo.budgets.status.revision_pending': 'Revisi menunggu',
  'bo.budgets.status.closed': 'Ditutup',
  'bo.budgets.policy.block': 'Blokir',
  'bo.budgets.policy.escalate': 'Eskalasi',
  'bo.budgets.policy.blockHint':
    'Permintaan dan pesanan pembelian yang melebihi sisa anggaran ditolak.',
  'bo.budgets.policy.escalateHint':
    'Pembelian yang melebihi sisa anggaran memerlukan persetujuan tambahan.',
  'bo.budgets.overBudget': 'Melebihi anggaran',
  'bo.budgets.utilizationLabel': 'Pemakaian {percent}',
  'bo.budgets.revisionNo': 'Revisi {revision}',
  'bo.budgets.proposedBy': 'oleh {name}',
  'bo.budgets.ownProposal': 'Anda yang mengusulkan nilai ini — orang lain yang harus memutuskan.',

  'bo.budgets.entries': 'Rincian',
  'bo.budgets.entriesNamed': 'Rincian {line}',
  'bo.budgets.editNamed': 'Ubah {line}',
  'bo.budgets.approveNamed': 'Setujui {line}',
  'bo.budgets.rejectNamed': 'Tolak {line}',

  'bo.budgets.createTitle': 'Pos anggaran baru',
  'bo.budgets.createDesc': 'Satu pos per periode, pusat biaya, dan kategori.',
  'bo.budgets.editTitle': 'Ubah {line}',
  'bo.budgets.form.createExplain':
    'Nilai ini berupa usulan: pos baru dapat dipakai setelah disetujui oleh orang lain.',
  'bo.budgets.form.periodLabel': 'Periode (bulan)',
  'bo.budgets.form.period': 'Pilih bulan.',
  'bo.budgets.form.costCenterHint': 'Mis. Dapur, Bar, Operasional.',
  'bo.budgets.form.categoryHint': 'Mis. Bahan makanan, Minuman, Perawatan.',
  'bo.budgets.form.required': 'Isi kolom ini.',
  'bo.budgets.form.duplicate':
    'Pos anggaran dengan pusat biaya dan kategori ini sudah ada untuk periode tersebut.',
  'bo.budgets.form.amount': 'Nilai ({currency}, satuan terkecil)',
  'bo.budgets.form.amountHint': 'Hanya angka, tanpa pemisah ribuan.',
  'bo.budgets.form.amountPreview': 'Nilai:',
  'bo.budgets.form.amountInvalid': 'Masukkan nilai bulat (hanya angka).',
  'bo.budgets.form.policy': 'Jika melebihi anggaran',
  'bo.budgets.form.notes': 'Catatan',
  'bo.budgets.form.createSubmit': 'Usulkan pos anggaran',
  'bo.budgets.form.noChanges': 'Tidak ada perubahan.',
  'bo.budgets.form.reviseApproved':
    'Mengubah nilai pos yang sudah disetujui membuka revisi: nilai disetujui tetap berlaku sampai orang lain menyetujui nilai baru. Kebijakan dan catatan langsung berubah.',
  'bo.budgets.form.revisePending':
    'Sudah ada revisi yang menunggu persetujuan. Nilai baru menggantikan usulan itu; nilai disetujui tetap berlaku sampai ada keputusan.',
  'bo.budgets.form.reviseDraft':
    'Pos ini belum disetujui. Nilai baru menggantikan usulan dan tetap perlu disetujui oleh orang lain.',
  'bo.budgets.created': 'Pos anggaran {line} diusulkan.',
  'bo.budgets.saved': 'Pos anggaran {line} disimpan.',
  'bo.budgets.revisionOpened': 'Revisi {line} diusulkan — menunggu persetujuan.',

  'bo.budgets.approve': 'Setujui',
  'bo.budgets.approving': 'Menyetujui…',
  'bo.budgets.approveTitle': 'Setujui nilai anggaran',
  'bo.budgets.approveNote': 'Catatan',
  'bo.budgets.approveNoteHint': 'Disimpan di log audit.',
  'bo.budgets.approved': '{line} disetujui.',
  'bo.budgets.reject': 'Tolak',
  'bo.budgets.rejecting': 'Menolak…',
  'bo.budgets.rejectTitle': 'Tolak nilai anggaran',
  'bo.budgets.rejectReason': 'Alasan',
  'bo.budgets.rejectReasonHint': 'Wajib. Pengusul dapat melihat alasan penolakan.',
  'bo.budgets.rejectDraftEffect': 'Pos tetap berstatus draf tanpa nilai sampai ada usulan baru.',
  'bo.budgets.rejectRevisionEffect': 'Nilai yang sudah disetujui sebelumnya tetap berlaku.',
  'bo.budgets.rejected': '{line} ditolak.',
  'bo.budgets.selfApproval':
    'Anda yang mengusulkan nilai ini, jadi Anda tidak dapat memutuskannya. Minta penyetuju lain.',
  'bo.budgets.decision.line': 'Pos anggaran',
  'bo.budgets.decision.period': 'Periode',
  'bo.budgets.decision.current': 'Disetujui saat ini',
  'bo.budgets.decision.proposed': 'Nilai usulan',
  'bo.budgets.decision.proposer': 'Diusulkan oleh',

  'bo.budgets.entriesTitle': 'Rincian · {line}',
  'bo.budgets.entriesDesc': 'Komitmen dan realisasi yang dibebankan ke pos anggaran ini.',
  'bo.budgets.entriesEmpty':
    'Belum ada rincian. Permintaan dan pesanan pembelian yang disetujui menambah komitmen; faktur pemasok yang diposting menambah realisasi.',
  'bo.budgets.entriesNote':
    'Nilai negatif melepas komitmen (mis. saat menjadi realisasi atau dibatalkan).',
  'bo.budgets.entry.kind': 'Jenis',
  'bo.budgets.entry.source': 'Sumber',
  'bo.budgets.entry.amount': 'Nilai',
  'bo.budgets.entry.reason': 'Alasan',
  'bo.budgets.entry.createdBy': 'Oleh',
  'bo.budgets.entry.createdAt': 'Waktu',
  'bo.budgets.entry.commitment': 'Komitmen',
  'bo.budgets.entry.actual': 'Realisasi',
  'bo.budgets.source.purchase_request': 'Permintaan pembelian',
  'bo.budgets.source.purchase_order': 'Pesanan pembelian',
  'bo.budgets.source.supplier_invoice': 'Faktur pemasok',
  'bo.budgets.source.credit_note': 'Nota kredit',

  'bo.budgets.definitionsTitle': 'Definisi',
  'bo.budgets.definitionsDesc': 'Cara server menghitung setiap angka.',
  'bo.budgets.definitionsNone': 'Tidak ada definisi yang dikirim.',
};
